import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { EnvironmentService } from '../../core/environment/environment.service';
import { MenuService } from '../../shared/header/menu/menu.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../../core/environment/environment.service";
import * as i3 from "../../shared/header/menu/menu.service";
var RecentSearchesService = /** @class */ (function () {
    function RecentSearchesService(http, environmentService, menuService) {
        this.http = http;
        this.environmentService = environmentService;
        this.menuService = menuService;
        this.recentSearchesSubject = new BehaviorSubject(null);
        this.apiUrl = this.environmentService.envModel.appSettings.apiUrlSearch;
    }
    RecentSearchesService.prototype.getRecentSearches = function (userId) {
        if (userId === void 0) { userId = 1; }
        var serviceUrl = this.buildServiceUrl(userId);
        return this.http.get(this.apiUrl + serviceUrl);
    };
    RecentSearchesService.prototype.getUpdatedRecentSearches = function () {
        var _this = this;
        this.menuService.getMenu().subscribe(function (menu) {
            _this.recentSearches = _this.filterMenuItems(menu);
            _this.recentSearchesSubject.next(_this.recentSearches);
        });
        return this.recentSearchesSubject.asObservable();
    };
    RecentSearchesService.prototype.filterMenuItems = function (menu) {
        var selectedMenuItems = [];
        var subMenuIndexes = [-15012, -15015, -15017, -11039, -15341];
        var optionalItems = [];
        menu.forEach(function (menuItem) {
            if (menuItem.categories != null) {
                menuItem.categories.forEach(function (category) {
                    if (category.subMenus != null) {
                        category.subMenus.forEach(function (subMenu) {
                            if (subMenuIndexes.includes(subMenu.id))
                                selectedMenuItems.push(subMenu);
                            else if (optionalItems.length < 5)
                                optionalItems.push(subMenu);
                        });
                    }
                });
            }
        });
        if (selectedMenuItems.length < 5) {
            var remainingItems = 5 - selectedMenuItems.length;
            var optionalCount = optionalItems.length;
            if (remainingItems > optionalCount) {
                for (var i = 0; i < optionalItems.length; i++) {
                    selectedMenuItems.push(optionalItems[i]);
                }
            }
            else {
                for (var i = 0; i < remainingItems; i++) {
                    selectedMenuItems.push(optionalItems[i]);
                }
            }
        }
        return selectedMenuItems;
    };
    RecentSearchesService.prototype.buildServiceUrl = function (userId) {
        return '/api/' + userId + '/recentSearches';
    };
    RecentSearchesService.ngInjectableDef = i0.defineInjectable({ factory: function RecentSearchesService_Factory() { return new RecentSearchesService(i0.inject(i1.HttpClient), i0.inject(i2.EnvironmentService), i0.inject(i3.MenuService)); }, token: RecentSearchesService, providedIn: "root" });
    return RecentSearchesService;
}());
export { RecentSearchesService };
